import { Box, chakra, Flex, Text, TextProps } from '@chakra-ui/react';
import { Color } from 'presentation/theme/colorScheme';
import { FC, PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  label: string;
  labelProps?: TextProps;
  showBorder?: boolean;
}

const CardInfoRow: FC<Props> = ({
  label,
  labelProps = {},
  children,
  showBorder = true,
  ...props
}) => {
  return (
    <Flex
      borderBottom={showBorder ? '2px solid' : 'none'}
      borderBottomColor={Color.Shade100}
      py="10px"
      alignItems="center"
      w="100%"
      justifyContent="space-between"
      {...props}
    >
      <Text mr={4} {...labelProps}>
        {label}
      </Text>
      <Box fontWeight={700} textAlign="right">
        {children}
      </Box>
    </Flex>
  );
};

export default chakra(CardInfoRow);
